// app/page.tsx
import Link from 'next/link';
import { SignInButton, SignOutButton, UserButton } from '@clerk/nextjs';

const HomePage = () => {
    return (
        <div>
            <h1>Sail the Boat Game</h1>
            <UserButton />
            <SignInButton />
            <SignOutButton />
            <br />
            <Link href="/game">Start Game</Link> {/* This will redirect to game page */}
        </div>
    );
};

export default HomePage;